<template>
  <div class="traceability">
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Traceability',
}
</script>

<style lang="scss">
.traceability {
  height: 100%;
  font-family: 'Exo 2', sans-serif !important;
}
</style>
